<div class="otherCourriers">
  <div class="page ">

    <!-- details courriers interne -->

    <div>
      <form id="signataireform" #form="ngForm" (ngSubmit)="onSubmit(form)">
        <div class="d-flex justify-content-between">
          <!-- <h1>Casiers</h1>			 -->
          <div class="actionBtn mt-3 col-md-3 col-lg-3 pb-2">
            <div class="addButton">
              <button class="button b1" type="submit">Enregistrer</button>
            </div>
          </div>
          <div class=" actionBtn mt-3 col-md-3 col-lg-3">

            <div class="addButton" id="addSignataire">
              <div class="button b1 "> Ajouter un signataire</div>
            </div>
          </div>
        </div>
        <div class="pc3 pc3-effect-scale pc3-theme-1">
          <input type="radio" name="pc3" checked id="other-tab1" class="tab-content-first">
          <label for="other-tab1">Liste des signataires</label>

          <ul style="height: 500px;">
            <li class="tab-content tab-content-first typography" style="height: 600px;">

              <div class="card mb-4 w-100">
                <div class=" tabhead card-header pb-0 d-flex justify-content-center">
                  <h6 class="salhead text-light">Liste des Signataires</h6>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive" style="margin: auto;min-height: 300px">
                    <table id="myTableSignataire"
                      class="table table-striped text-nowrap table-responsive text-center w-100 d-block d-md-table"
                      style="font-size: 12px;">
                      <thead class="text-dark">
                        <tr>
                          <th>Prenom</th>
                          <th>Nom</th>
                          <th>Numero d'identification</th>
                          <th>Fonction</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Lignes ajoutées ici dynamiquement via le jquery -->
                        <tr *ngFor="let signataire of signataires">
                          <td><input type="text" class="form-control" name="firstName" value="{{signataire.firstName}}">
                          </td>
                          <td><input type="text" class="form-control" name="lastName" value="{{signataire.lastName}}">
                          </td>
                          <td><input type="text" class="form-control" name="numeroIdentification"
                              value="{{signataire.numeroIdentification}}"></td>
                          <td>
                            <select name="fonction" class="form-control" id="">
                              <option value="" selected>Procureur</option>
                              <option value="">Juge d'instruction</option>
                              <option value="">Greffier</option>
                            </select>
                          </td>
                          <td>
                            <!-- <i class="fas fa-solid fa-pen text-primary signer mt-2 px-2"
                              style="font-size:20px; cursor:pointer"></i> -->
                            <i class="fas fa-solid fa-trash delete-row text-danger mt-2"
                              style="font-size:20px; cursor:pointer"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </form>
    </div>

    <!--/ tabs -->


  </div>
</div>
